/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Sports_Physio_TermsInputs */

const en_service_type_sports_physio_terms = /** @type {(inputs: Service_Type_Sports_Physio_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sports physio, sports injury, athlete, runner, return to sport`)
};

const pl_service_type_sports_physio_terms = /** @type {(inputs: Service_Type_Sports_Physio_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fizjoterapeuta sportowy, kontuzje sportowe, sportowiec, biegacz, powrót do sportu`)
};

/**
* | output |
* | --- |
* | "sports physio, sports injury, athlete, runner, return to sport" |
*
* @param {Service_Type_Sports_Physio_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_sports_physio_terms = /** @type {((inputs?: Service_Type_Sports_Physio_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Sports_Physio_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_sports_physio_terms(inputs)
	return en_service_type_sports_physio_terms(inputs)
});